<span class="badge rounded-pill {{ badgeClass }} fw-normal">{{ value }}</span>
